// removed by extract-text-webpack-plugin
module.exports = {"home":"home__MseGd"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/style.css
// module id = ZAL5
// module chunks = 0